import React, { useState, useEffect } from "react";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import AuthPage from "./pages/AuthPage";
import UnlockPage from "./pages/UnlockPage";
import NavigationContext from "./components/NavigationContext";
import HttpService from "./sdk/HttpAxios";

function App() {
  const [currentPage, setCurrentPage] = useState("unlock");
  const [phone, setPhone] = useState("");
  const [disableHome, setDisableHome] = useState(false);
  const [userData, setUserData] = useState({
    name: "",
    email: "",
  });

  /**
   * Handle refresh / deep link:
   *  - /unlock?terminal=xxx
   */
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const terminal = params.get("terminal");

    if (window.location.pathname === "/unlock" && terminal) {
      setCurrentPage("unlock");
    } else {
      // setCurrentPage("home");
      setCurrentPage("unlock");
    }
  }, []);

  /**
   * SPA-safe navigation to unlock page
   */
  const navigateToUnlock = () => {
    setCurrentPage("unlock");

    window.history.pushState({}, "", `/unlock`);
  };

  /**
   * Navigate home
   */
  const navigateHome = () => {
    setCurrentPage("home");
    window.history.pushState({}, "", `/`);
  };

  /**
   * Step 2 → Login
   */
  const onLogin = async (phoneNumber) => {
    const http = new HttpService();
    await http.loginWithOtp(phoneNumber);

    setPhone(phoneNumber); // ✅ FIX
    setCurrentPage("auth");
  };

  console.log("currentPage: ", currentPage);

  return (
    <NavigationContext.Provider
      value={{
        navigateHome,
        disableHome,
        setDisableHome,
      }}
    >
      {currentPage === "" && <>Loading…</>}

      {/* 1️⃣ Instructions */}
      {currentPage === "home" && (
        <HomePage onNext={() => setCurrentPage("login")} />
      )}

      {/* 2️⃣ Phone Login */}
      {currentPage === "login" && <LoginPage onNext={onLogin} />}

      {/* 3️⃣ OTP + Profile */}
      {currentPage === "auth" && (
        <AuthPage
          phone={phone}
          userName={userData.name}
          email={userData.email}
          onNext={(finalUser) => {
            setUserData({
              name: finalUser.name,
              email: finalUser.email,
            });

            navigateToUnlock();
          }}
        />
      )}

      {/* 4️⃣ Unlock */}
      {currentPage === "unlock" && <UnlockPage />}
    </NavigationContext.Provider>
  );
}

export default App;
